import React from 'react'
import PropTypes from 'prop-types'

import { StyledCircleButton } from './styles'

const CircleButton = ({ id, dataGa = '', onClick = () => {}, isClicked = false, icon, label = '', type = '' }) => {
  const handleOnClick = () => {
    if (!isClicked) onClick()
  }

  return (
    <StyledCircleButton id={id} data-ga={dataGa} onClick={handleOnClick} $type={type}>
      {icon && icon}
      <i>{label}</i>
    </StyledCircleButton>
  )
}

CircleButton.propTypes = {
  id: PropTypes.string,
  type: PropTypes.string,
  dataGa: PropTypes.string,
  icon: PropTypes.any,
  isClicked: PropTypes.bool,
  label: PropTypes.string,
  onClick: PropTypes.func,
}

export default CircleButton
